import { PageSection } from '@patternfly/react-core'
import * as React from 'react'
import styled from 'styled-components'

import { ResponseHistory } from '@app/components/patient/response-history'
import type { IPatientId } from '@app/domain/patient/patient.interface'

export interface Props {
  patientId: IPatientId
}

const Wrapper = styled.div`
  .pf-c-page__main-section {
    padding-top: 0.75rem;
  }
`

export const ResponseHistoryTabContent = ({ patientId }: Props) => {
  return (
    <Wrapper>
      <PageSection>
        <ResponseHistory patientId={patientId} />
      </PageSection>
    </Wrapper>
  )
}
